import {
  Amount,
  ItineraryCandidate,
} from './CreateItinerary/CreateItineraryForm';
import AmountUtils from './CreateAmount/utils';
import { BudgetInstance } from './CreateBudget/CreateBudgetForm';

export const computeItineraryTotalWithoutVAT = (
  itinerary: ItineraryCandidate,
): number => {
  return itinerary.amounts.reduce((total: number, currentValue: Amount) => {
    return total + currentValue.amount;
  }, 0);
};

export const computeItineraryTotalWithVAT = (
  itinerary: ItineraryCandidate,
): number => {
  return itinerary.amounts.reduce((total: number, currentValue: Amount) => {
    return total + AmountUtils.calculateTotalWithVat(currentValue);
  }, 0);
};

export const computeItineraryVATSumatory = (itinerary: ItineraryCandidate) => {
  return itinerary.amounts.reduce((total: number, currentValue: Amount) => {
    return total + AmountUtils.calculateVATAmount(currentValue);
  }, 0);
};

export const computeBudgetTotalWithVAT = (budget: BudgetInstance) => {
  return budget.itineraries.reduce(
    (total: number, currentValue: ItineraryCandidate) => {
      return total + computeItineraryTotalWithVAT(currentValue);
    },
    0,
  );
};
